import { createSelector } from 'reselect';
import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
import { createSelector as repackagedCreateSelector } from 'ContentEditorUI/types/createSelector';
import { getPreviewViewportWidth, getHighlightedWidgetId, getHighlightedWidgetContainerId } from 'ContentEditorUI/redux/selectors/inpageSelectors';
import { getSelectedItemId, getSelectedContainerId, getIsAnythingSelected } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import { FLEX_COLUMN_MODULES_CONFIG, GLOBAL_GROUPS_CONFIG, GLOBAL_PARTIALS_CONFIG, NESTED_MODULES_IN_RTE_CONFIG, POST_BODY_MODULES_CONFIG, dropTypes } from 'InpageEditorUI/lib/layoutSection/constants';
import { getHasAnyFlexColumns, getHasAnyLayoutSections, getAllLayoutSectionTreesAsMap } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getIsModuleIdInAdvancedModuleIdsWithoutAccessMap, getAdvancedModuleWithoutAccessInfo, getIsModuleIdInPaymentsModulesWithoutAccessSet, getIsModuleInPersonalizationTokensWithoutAccessMap, getIsMissingAccessToSomeAdvancedModule
// @ts-expect-error not typed yet
} from 'ContentEditorUI/redux/selectors/downgradeSelectors';
import { getScrollToNodePositionId } from 'ContentEditorUI/redux/selectors/inpageSelectors';
import { resizeHandleTypes, dropTargetLocations, ROW_DRAG_HANDLE, COLUMN_DRAG_HANDLE, MODULE_DRAG_HANDLE, EMPTY_CONTAINER_DRAG_HANDLE, TOPMOST_SECTION_ROW_DRAG_HANDLE, INSERT_NEW_SECTION_HANDLE } from 'InpageEditorUI/lib/layoutSection/constants';
import { getPositionInfoForResizeHandle, isResizeHandleType } from 'InpageEditorUI/lib/layoutSection/resizeHandleHelpers';
// @ts-expect-error not typed yet
import { arrangeNodePositionsById } from 'layout-dnd-utils/nodePositions/nodePositionUtils';
import { EDGE_TOOLBAR_HEIGHT, PINNED_TOOLBAR_HEIGHT, ROUNDED_BUTTON_HEIGHT, RESPONSIVE_SIZES } from 'layout-dnd-components/js/DndToolbar/constants';
import { getIsInNonDefaultBreakpointMode } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { TOP, BEFORE, AFTER } from 'layout-dnd-utils/js/constants';
import { SHADE_BELOW, SHADE_ABOVE, SHADE_BOTH, SHADE_RIGHT, SHADE_LEFT
// @ts-expect-error not typed yet
} from 'layout-dnd-components/InsertDropTargets';
import { NUMBER_DND_AREA_TOOLBAR_TYPES, TOOLBAR_TYPES, getDragHandleByType, findAppropriateToolbarSize, adjustResponsiveToolbarToStayInViewPort, SELECTED_TOOLBAR_OFFSET, shouldShowEditModuleOnSelected } from 'InpageEditorUI/lib/toolbarUtils';
import { LAYOUT_SECTIONS_CONFIG, ALL_NODE_POSITION_CONFIG_KEYS, STATIC_MODULES_CONFIG } from 'InpageEditorUI/lib/layoutSection/constants';
import { getIsInLegacyLayoutMode } from 'ContentEditorUI/redux/selectors/inpageSelectors';
import { getHasPaymentsReadAccess, getHasPersonalizationAccess } from 'ContentEditorUI/redux/selectors/authSelectors';
// @ts-expect-error not typed yet
import { getNodePositionConfig } from 'InpageEditorUI/redux/selectors/nodePositionConfigSelectors';
import { getHasTheme } from 'ContentEditorUI/redux/selectors/themeSelectors';
// @ts-expect-error not typed yet
import { getFeatureFlag } from 'ContentEditorUI/redux/selectors/featureFlagsSelectors';
import { FEATURE_FLAGS } from 'ContentEditorUI/redux/constants';
import { getIsPatagoniaSidebarCollapsed } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { getIsDataAuthoringModeActive } from 'ContentEditorUI/redux/selectors/instanceEditingSelectors';
import get from 'hs-lodash/get';
const childIdsFromNode = (tree, nodeId) => {
  if (!tree) return [];
  const cellOrRow = tree.hasRow(nodeId) ? tree.findRow(nodeId) : tree.hasCell(nodeId) && tree.findCell(nodeId);
  if (!cellOrRow) return [];
  return cellOrRow.isRow() ? cellOrRow.getColumnNames() : cellOrRow.getRowNames();
};
const getLayoutSectionDndState = basicSelector(state => state.layoutSectionDnd);
const createLayoutSectionDndSelector = field => {
  return createSelector([getLayoutSectionDndState], state => state[field]);
};
export const getCurrentDragItem = createLayoutSectionDndSelector('currentDragItem');
export const getDragItemIsHidden = createSelector([getCurrentDragItem], currentDragItem => {
  var _ref;
  return (_ref = !!currentDragItem && currentDragItem.hidden) !== null && _ref !== void 0 ? _ref : false;
});
export const getIsMouseInIFrame = createLayoutSectionDndSelector('mouseIsInIFrame');
export const getCurrentDropTarget = createLayoutSectionDndSelector('currentDropTarget');
const getHoveredPositionsDeepestFirst = createLayoutSectionDndSelector('hoveredPositionsDeepestFirst');
export const getMouseCoordsAtDrop = createLayoutSectionDndSelector('mouseCoordsAtDrop');
export const getNodePositions = createLayoutSectionDndSelector('nodePositions');
export const getNodePositionsNeedUpdate = createLayoutSectionDndSelector('nodePositionsNeedUpdate');
export const getHoverPositionsFrozen = createLayoutSectionDndSelector('hoverPositionsFrozen');
export const getBodyOffset = createLayoutSectionDndSelector('bodyOffset');
const getScrollPosition = createLayoutSectionDndSelector('scrollPosition');
export const getScrollLeftPosition = createSelector(getScrollPosition, scrollPosition => {
  var _scrollPosition$left;
  return (_scrollPosition$left = scrollPosition.left) !== null && _scrollPosition$left !== void 0 ? _scrollPosition$left : 0;
});
export const getScrollTopPosition = createSelector(getScrollPosition, scrollPosition => {
  var _scrollPosition$top;
  return (_scrollPosition$top = scrollPosition.top) !== null && _scrollPosition$top !== void 0 ? _scrollPosition$top : 0;
});
export const getNodePositionsBeforeTreeChange = createLayoutSectionDndSelector('nodePositionsBeforeTreeChange');
const getRawDragHandles = createLayoutSectionDndSelector('currentDragHandles');
export const getNodePositionsByConfigAndId = createSelector(getNodePositions, getNodePositionConfig, (nodePositions, nodePositionsConfig) => {
  return arrangeNodePositionsById(nodePositions, nodePositionsConfig);
});
const getNodePositionsBeforeTreeChangeByConfigAndId = createSelector(getNodePositionsBeforeTreeChange, getNodePositionConfig, (nodePositionsBeforeTreeChange, nodePositionsConfig) => {
  return arrangeNodePositionsById(nodePositionsBeforeTreeChange, nodePositionsConfig);
});
const findNodePositionForLookupId = (nodePositionsByConfigAndId, lookupId, containerLookupId) => {
  if (!lookupId) {
    return undefined;
  }
  for (const configKey of ALL_NODE_POSITION_CONFIG_KEYS) {
    let positionsById = nodePositionsByConfigAndId[configKey];
    if (containerLookupId && positionsById &&
    // Edge case for static section modules, which have parents, but are treated as static module
    positionsById[containerLookupId]) {
      // @ts-expect-error TODO: Clean up node position types
      positionsById = positionsById[containerLookupId];
    }
    if (positionsById && Object.prototype.hasOwnProperty.call(positionsById, lookupId)) {
      // @ts-expect-error TODO: Clean up node position types
      return positionsById[lookupId];
    }
  }
  return undefined;
};
const findNodePositionFor = (nodePositionsByConfigAndId, hoverPositionOrHandle) => {
  if (!hoverPositionOrHandle) {
    return undefined;
  }
  const lookupId = hoverPositionOrHandle.uniquePositionId || hoverPositionOrHandle.id;
  const containerLookupId = hoverPositionOrHandle.layoutSectionId;
  return findNodePositionForLookupId(nodePositionsByConfigAndId, lookupId, containerLookupId);
};
export const getNodePositionsByTreeId = createSelector(getNodePositionsByConfigAndId, nodePositionsByConfigAndId => {
  return nodePositionsByConfigAndId[LAYOUT_SECTIONS_CONFIG];
});
export const getNodePositionsByStaticModuleId = createSelector(getNodePositionsByConfigAndId, nodePositionsByConfigAndId => nodePositionsByConfigAndId[STATIC_MODULES_CONFIG]);
export const getNodePositionsBeforeTreeChangeByTreeId = createSelector(getNodePositionsBeforeTreeChangeByConfigAndId, nodePositionsBeforeTreeChangeByConfigAndId => {
  return nodePositionsBeforeTreeChangeByConfigAndId[LAYOUT_SECTIONS_CONFIG];
});
export const getTargetedOrNearbyLayoutSectionId = createLayoutSectionDndSelector('targetedLayoutSectionId');
export const getTargetedLayoutSectionId = createSelector([getTargetedOrNearbyLayoutSectionId, getHoveredPositionsDeepestFirst], (layoutSectionId, hoveredPositions) => {
  const targetedLayoutSection = hoveredPositions.at(-1);
  if (targetedLayoutSection && targetedLayoutSection.inBufferZone) {
    return null;
  }
  return layoutSectionId;
});

// https://issues.hubspotcentral.com/browse/CG-40993
// Only use targetedLayoutSectionId if it exists, and nothing is selected.
const getTargetedLayoutSectionIdIfNothingIsSelected = createSelector([getTargetedLayoutSectionId, getIsAnythingSelected], (targetedLayoutSectionId, isAnythingSelected) => {
  if (!isAnythingSelected && targetedLayoutSectionId) {
    return targetedLayoutSectionId;
  }
  return null;
});
export const getTargetedOrNearbyDndAreaNodePositionsById = createSelector([getNodePositionsByTreeId, getTargetedOrNearbyLayoutSectionId], (nodePositionsByTreeId, targetedLayoutSectionId) => {
  return nodePositionsByTreeId ? nodePositionsByTreeId[targetedLayoutSectionId] : undefined;
});
export const getTargetedDndAreaNodePositionsById = createSelector([getNodePositionsByTreeId, getTargetedLayoutSectionId], (nodePositionsByTreeId, targetedLayoutSectionId) => {
  return nodePositionsByTreeId ? nodePositionsByTreeId[targetedLayoutSectionId] : undefined;
});
export const getTargetedTree = createSelector([getTargetedOrNearbyLayoutSectionId, getAllLayoutSectionTreesAsMap], (targetedLayoutSectionId, allLayoutSectionTreesAsMap) => {
  return allLayoutSectionTreesAsMap[targetedLayoutSectionId];
});
export const getHoveredSubTree = createSelector([getSelectedItemId, getAllLayoutSectionTreesAsMap], (selectedItemId, allLayoutSectionTreesAsMap) => {
  return allLayoutSectionTreesAsMap[selectedItemId];
});
export const getHoveredDragHandleType = createLayoutSectionDndSelector('hoveredDragHandleType');
const getCurrentColumnResizeHandles = createLayoutSectionDndSelector('currentColumnResizeHandles');
export const getHasInsertNewSectionHandleHovered = createSelector(getHoveredDragHandleType, hoveredDragHandleType => hoveredDragHandleType === INSERT_NEW_SECTION_HANDLE);
const getDeepestHoveredItem = createSelector([getHoveredPositionsDeepestFirst], hoveredPositionsDeepestFirst => {
  var _hoveredPositionsDeep;
  return (_hoveredPositionsDeep = hoveredPositionsDeepestFirst.at(0)) !== null && _hoveredPositionsDeep !== void 0 ? _hoveredPositionsDeep : null;
});
const getSecondToLastHoveredItem = createSelector([getHoveredPositionsDeepestFirst], hoveredPositionsDeepestFirst => {
  var _hoveredPositionsDeep2;
  if (hoveredPositionsDeepestFirst.length < 2) {
    return null;
  }
  return (_hoveredPositionsDeep2 = hoveredPositionsDeepestFirst.at(hoveredPositionsDeepestFirst.length - 2)) !== null && _hoveredPositionsDeep2 !== void 0 ? _hoveredPositionsDeep2 : null;
});
const getHoveredSectionId = createSelector(getSecondToLastHoveredItem, secondToLastHoveredItem => {
  return secondToLastHoveredItem ? secondToLastHoveredItem.id : undefined;
});
export const getIsAnythingDragging = createSelector(getCurrentDragItem, currentDragItem => !!currentDragItem);
export const getShouldShowGridAndToolbars = repackagedCreateSelector(getIsMouseInIFrame, getHoverPositionsFrozen, getIsInLegacyLayoutMode, (mouseIsInIFrame, hoverPositionsFrozen,
// Don't show grid, overlays, and toolbars if in flex column layout mode
isInLegacyLayoutMode) => (mouseIsInIFrame || hoverPositionsFrozen) && !isInLegacyLayoutMode);

// Similar to getShouldShowGridAndToolbars, but also always show gride whenever dragging
export const getShouldShowGrid = repackagedCreateSelector(getIsInLegacyLayoutMode, getIsAnythingDragging, getHasInsertNewSectionHandleHovered, getIsDataAuthoringModeActive, (
// Don't show grid, overlays, and toolbars if in flex column layout mode
isInLegacyLayoutMode, isAnythingDragging, isInsertNewSectionHandleHovered, isDataAuthoringModeActive) => {
  return isAnythingDragging || !isInLegacyLayoutMode && !isInsertNewSectionHandleHovered && !isDataAuthoringModeActive;
});
export const getHoveredResizeHandleType = createSelector(getHoveredDragHandleType, hoveredDragHandleType => {
  if (hoveredDragHandleType && isResizeHandleType(hoveredDragHandleType)) {
    return hoveredDragHandleType;
  }
  return null;
});
export const getIsAnyResizeHandleHovered = createSelector(getHoveredDragHandleType, hoveredDragHandleType => !!hoveredDragHandleType && isResizeHandleType(hoveredDragHandleType));
const getIsDraggingResizeHandle = createSelector(getIsAnythingDragging, getIsAnyResizeHandleHovered, (isAnythingDragging, isResizeHandleHovered) => isAnythingDragging && isResizeHandleHovered);
export const getCurrentColumnInsertTargetInfo = createSelector(getCurrentDropTarget, getTargetedOrNearbyDndAreaNodePositionsById, (dropTarget, targetedDndAreaNodePositionsById) => {
  if (dropTarget && targetedDndAreaNodePositionsById) {
    const type = dropTarget.type;
    const currentColumnPosition = targetedDndAreaNodePositionsById[dropTarget.id];
    // TODO [RR]: Enhance dropTarget data to include module/column type so we don't need to split.
    const isBetweenItems = !!(dropTarget.nextColumnId || dropTarget.previousColumnId);
    const dropType = dropTarget.id && dropTarget.id.split('_')[0];
    const isSingleModuleWrappedInSection = currentColumnPosition.depth === 2;
    let shade;
    if (type === dropTypes.INSERT_COLUMN_BEFORE) {
      const previousColumnId = dropTarget.previousColumnId;
      const previousColumnPosition = targetedDndAreaNodePositionsById[previousColumnId] || {
        top: currentColumnPosition.top,
        height: currentColumnPosition.height,
        right: currentColumnPosition.left
      };
      if (isBetweenItems || dropType === 'cell' || isSingleModuleWrappedInSection) {
        shade = SHADE_BOTH;
      } else {
        shade = SHADE_RIGHT;
      }
      return {
        type: dropTargetLocations.BEFORE,
        top: Math.min(previousColumnPosition.top, currentColumnPosition.top),
        height: Math.max(previousColumnPosition.height, currentColumnPosition.height),
        left: (previousColumnPosition.right + currentColumnPosition.left) / 2,
        shade
      };
    } else if (type === dropTypes.INSERT_COLUMN_AFTER) {
      const nextColumnId = dropTarget.nextColumnId;
      const nextColumnPosition = targetedDndAreaNodePositionsById[nextColumnId] || {
        top: currentColumnPosition.top,
        height: currentColumnPosition.height,
        left: currentColumnPosition.right
      };
      if (isBetweenItems || dropType === 'cell' || isSingleModuleWrappedInSection) {
        shade = SHADE_BOTH;
      } else {
        shade = SHADE_LEFT;
      }
      return {
        type: dropTargetLocations.AFTER,
        top: Math.min(nextColumnPosition.top, currentColumnPosition.top),
        height: Math.max(nextColumnPosition.height, currentColumnPosition.height),
        left: (nextColumnPosition.left + currentColumnPosition.right) / 2,
        shade
      };
    } else if (type === dropTypes.PREPEND_ROW) {
      return {
        type: dropTargetLocations.SPLIT_ROW_BEFORE,
        left: currentColumnPosition.left,
        width: currentColumnPosition.width,
        top: currentColumnPosition.top,
        shade: SHADE_BELOW
      };
    } else if (type === dropTypes.APPEND_ROW) {
      return {
        type: dropTargetLocations.SPLIT_ROW_AFTER,
        left: currentColumnPosition.left,
        width: currentColumnPosition.width,
        top: currentColumnPosition.bottom,
        shade: SHADE_ABOVE
      };
    }
  }
  return null;
});
export const getCurrentRowInsertTargetInfo = createSelector(getCurrentDropTarget, getTargetedOrNearbyDndAreaNodePositionsById, (dropTarget, targetedDndAreaNodePositionsById) => {
  if (dropTarget && targetedDndAreaNodePositionsById) {
    const type = dropTarget.type;
    const currentRowPosition = targetedDndAreaNodePositionsById[dropTarget.id];
    let shade;
    // TODO [RR]: Enhance dropTarget data to include module/column type so we don't need to split.
    const parentColumnType = dropTarget.parentColumnId && dropTarget.parentColumnId.split('_')[0];
    const isBetweenItems = !!(dropTarget.nextRowId || dropTarget.previousRowId);
    if (type === dropTypes.INSERT_ROW_BEFORE) {
      const previousRowPosition = targetedDndAreaNodePositionsById[dropTarget.previousRowId] || {
        left: currentRowPosition.left,
        width: currentRowPosition.width,
        bottom: currentRowPosition.top
      };
      if (isBetweenItems || parentColumnType === 'module') {
        shade = SHADE_BOTH;
      } else if (parentColumnType === 'cell') {
        shade = SHADE_BELOW;
      }
      return {
        type: dropTargetLocations.BEFORE,
        left: Math.min(previousRowPosition.left, currentRowPosition.left),
        width: Math.max(previousRowPosition.width, currentRowPosition.width),
        top: (previousRowPosition.bottom + currentRowPosition.top) / 2,
        previousRowId: dropTarget.previousRowId,
        shade
      };
    } else if (type === dropTypes.INSERT_ROW_AFTER) {
      const nextRowPosition = targetedDndAreaNodePositionsById[dropTarget.nextRowId] || {
        left: currentRowPosition.left,
        width: currentRowPosition.width,
        top: currentRowPosition.bottom
      };
      if (isBetweenItems || parentColumnType === 'module') {
        shade = SHADE_BOTH;
      } else if (parentColumnType === 'cell') {
        shade = SHADE_ABOVE;
      }
      return {
        type: dropTargetLocations.AFTER,
        left: Math.min(nextRowPosition.left, currentRowPosition.left),
        width: Math.max(nextRowPosition.width, currentRowPosition.width),
        top: (nextRowPosition.top + currentRowPosition.bottom) / 2,
        nextRowId: dropTarget.nextRowId,
        shade
      };
    }
  }
  return null;
});
export const getDeepestHoveredNodePositionInfo = createSelector(getDeepestHoveredItem, getNodePositionsByConfigAndId, (deepestItem, nodePositionsByConfigAndId) => {
  if (nodePositionsByConfigAndId && deepestItem) {
    return findNodePositionFor(nodePositionsByConfigAndId, deepestItem);
  }
  return undefined;
});
export const getHoveredNodeInfoDeepestFirst = createSelector(getHoveredPositionsDeepestFirst, getNodePositionsByConfigAndId, (hoveredPositionsDeepestFirst, nodePositionsByConfigAndId) => {
  if (Object.keys(nodePositionsByConfigAndId).length > 0) {
    return hoveredPositionsDeepestFirst.map(hoverPosition => findNodePositionFor(nodePositionsByConfigAndId, hoverPosition));
  }
  return [];
});
export const getTopMostRowNodeInfo = createSelector(getHoveredNodeInfoDeepestFirst, hoveredNodeInfoDeepestFirst => {
  for (const nodeInfo of hoveredNodeInfoDeepestFirst) {
    if (nodeInfo && nodeInfo.depth === 1) {
      return nodeInfo;
    }
  }
  return undefined;
});
const getCurrentDragHandles = createSelector(getRawDragHandles, getHoveredDragHandleType, (rawDragHandles, hoveredDragHandleType) => {
  if (hoveredDragHandleType && rawDragHandles) {
    const hoveredHandleIndex = rawDragHandles.findIndex(handle => handle.type === hoveredDragHandleType);
    if (hoveredHandleIndex > 0) {
      return rawDragHandles.slice(hoveredHandleIndex);
    }
  }
  return rawDragHandles;
});
const getCurrentHoveredDragHandle = createSelector(getCurrentDragHandles, getHoveredDragHandleType, (currentDragHandles, hoveredDragHandleType) => {
  if (!currentDragHandles) {
    return null;
  }
  for (const handle of currentDragHandles) {
    if (handle.type === hoveredDragHandleType) {
      return handle;
    }
  }
  return null;
});

// In "showDndGridWhileSelected" UX we are:
//  - All D&D grid, overlays, and toolbars are shown when _nothing_ is selected
//  - Show the D&D "grid" (gray lines) when something is selected
//  - Show the module overlays and toolbars when something is selected
//  - Do _not_ show container overlays and toolbars when something is selected
const getShouldCalculateContainerToolbars = createSelector(getIsAnythingSelected, isAnythingSelected => !isAnythingSelected);

// Get the deepest row/column handle _excluding_ the top-most section row
export const getCurrentDeepestRowOrColumnIdWithDragHandle = createSelector(getCurrentDragHandles, currentDragHandles => {
  if (currentDragHandles) {
    for (const handle of currentDragHandles) {
      if (handle.type === ROW_DRAG_HANDLE || handle.type === COLUMN_DRAG_HANDLE) {
        return handle.id;
      }
    }
  }
  return null;
});
export const getCurrentTopmostRowIdWithDragHandle = createSelector(getCurrentDragHandles, currentDragHandles => {
  const hasTopmostRowDragHandle = currentDragHandles && currentDragHandles.length > 0 && currentDragHandles.at(-1).type === TOPMOST_SECTION_ROW_DRAG_HANDLE;
  if (hasTopmostRowDragHandle) {
    return currentDragHandles.at(-1).id;
  }
  return null;
});
const getMeasuredToolbarDimensions = createSelector(getLayoutSectionDndState, state => state.measuredToolbarDimensions);
const getNumberOfToolbarMeasurements = createSelector(getMeasuredToolbarDimensions, measuredToolbarDimensions => Object.values(measuredToolbarDimensions).map(measurementsForType => Object.keys(measurementsForType).length).reduce((t, size) => t + size, 0));
const getNumberOfResponsiveToolbarTypes = createSelector(getHasAnyFlexColumns, getHasAnyLayoutSections, (hasAnyFlexColumns, hasAnyLayoutSections) => {
  let numToolbarTypes = 1;
  if (hasAnyFlexColumns) {
    numToolbarTypes += 1;
  }
  if (hasAnyLayoutSections) {
    numToolbarTypes += NUMBER_DND_AREA_TOOLBAR_TYPES;
  }
  return numToolbarTypes;
});
export const getHasAllResponsiveToolbarMeasurements = createSelector(getNumberOfToolbarMeasurements, getNumberOfResponsiveToolbarTypes, (numberOfToolbarMeasurements, numberOfResponsiveToolbarTypes) => numberOfToolbarMeasurements >= RESPONSIVE_SIZES.length * numberOfResponsiveToolbarTypes);

// Returns an object like { default, medium, small }
const collectDimensionForAllSizes = (name, dimension, measuredToolbarDimensions) => RESPONSIVE_SIZES.reduce((result, size) => {
  let measuredSize = 0;
  measuredSize = get(measuredToolbarDimensions, [name, size, dimension]);
  result[size] = measuredSize;
  return result;
}, {});
export const getMeasuredWidthsOfModuleOutsideContainerToolbarSizes = createSelector(getMeasuredToolbarDimensions, getIsInNonDefaultBreakpointMode, (measuredToolbarDimensions, isInNonDefaultBreakpointMode) => collectDimensionForAllSizes(isInNonDefaultBreakpointMode ? TOOLBAR_TYPES.MOBILE.MODULE_OUTSIDE_CONTAINER_TOOLBAR_TYPE : TOOLBAR_TYPES.DESKTOP.MODULE_OUTSIDE_CONTAINER_TOOLBAR_TYPE, 'width', measuredToolbarDimensions));
export const getMeasuredWidthsOfModuleInRichTextToolBarSizes = createSelector(getMeasuredToolbarDimensions, getIsInNonDefaultBreakpointMode, (measuredToolbarDimensions, isInNonDefaultBreakpointMode) => collectDimensionForAllSizes(isInNonDefaultBreakpointMode ? TOOLBAR_TYPES.MOBILE.MODULE_IN_RICH_TEXT : TOOLBAR_TYPES.DESKTOP.MODULE_IN_RICH_TEXT, 'width', measuredToolbarDimensions));
export const getMeasuredWidthsOfModuleInFlexColumnToolbarSizes = createSelector(getMeasuredToolbarDimensions, getIsInNonDefaultBreakpointMode, (measuredToolbarDimensions, isInNonDefaultBreakpointMode) => collectDimensionForAllSizes(isInNonDefaultBreakpointMode ? TOOLBAR_TYPES.MOBILE.MODULE_IN_FLEX_COLUMN_TOOLBAR_TYPE : TOOLBAR_TYPES.DESKTOP.MODULE_IN_FLEX_COLUMN_TOOLBAR_TYPE, 'width', measuredToolbarDimensions));
const getMeasuredWidthsOfSectionToolbarSizes = createSelector(getMeasuredToolbarDimensions, getIsInNonDefaultBreakpointMode, (measuredToolbarDimensions, isInNonDefaultBreakpointMode) => collectDimensionForAllSizes(isInNonDefaultBreakpointMode ? TOOLBAR_TYPES.MOBILE.SECTION_TOOLBAR_TYPE : TOOLBAR_TYPES.DESKTOP.SECTION_TOOLBAR_TYPE, 'width', measuredToolbarDimensions));
const getMeasuredWidthsOfInsertNewSectionHandleSizes = createSelector(getMeasuredToolbarDimensions, getIsInNonDefaultBreakpointMode, (measuredToolbarDimensions, isInNonDefaultBreakpointMode) => collectDimensionForAllSizes(isInNonDefaultBreakpointMode ? TOOLBAR_TYPES.MOBILE.INSERT_NEW_SECTION_HANDLE_TYPE : TOOLBAR_TYPES.DESKTOP.INSERT_NEW_SECTION_HANDLE_TYPE, 'width', measuredToolbarDimensions));
const getMeasuredWidthsOfColumnToolbarSizes = createSelector(getMeasuredToolbarDimensions, getIsInNonDefaultBreakpointMode, (measuredToolbarDimensions, isInNonDefaultBreakpointMode) => collectDimensionForAllSizes(isInNonDefaultBreakpointMode ? TOOLBAR_TYPES.MOBILE.COLUMN_TOOLBAR_TYPE : TOOLBAR_TYPES.DESKTOP.COLUMN_TOOLBAR_TYPE, 'width', measuredToolbarDimensions));
const getMeasuredHeightsOfRowToolbarSizes = createSelector(getMeasuredToolbarDimensions, getIsInNonDefaultBreakpointMode, (measuredToolbarDimensions, isInNonDefaultBreakpointMode) => collectDimensionForAllSizes(isInNonDefaultBreakpointMode ? TOOLBAR_TYPES.MOBILE.ROW_TOOLBAR_TYPE : TOOLBAR_TYPES.DESKTOP.ROW_TOOLBAR_TYPE, 'height', measuredToolbarDimensions));
const getMeasuredHeightsOfRowToolbarWithHideIconSizes = createSelector(getMeasuredToolbarDimensions, measuredToolbarDimensions => collectDimensionForAllSizes(TOOLBAR_TYPES.MOBILE.ROW_TOOLBAR_WITH_HIDE_ICON_TYPE, 'height', measuredToolbarDimensions));
const getMeasuredWidthsOfDndAreaModuleToolbarSizes = createSelector(getMeasuredToolbarDimensions, getIsInNonDefaultBreakpointMode, (measuredToolbarDimensions, isInNonDefaultBreakpointMode) => collectDimensionForAllSizes(isInNonDefaultBreakpointMode ? TOOLBAR_TYPES.MOBILE.MODULE_TOOLBAR_TYPE : TOOLBAR_TYPES.DESKTOP.MODULE_TOOLBAR_TYPE, 'width', measuredToolbarDimensions));
const getMeasuredWidthsOfAdvancedModuleWithoutAccessToolbarSizes = createSelector([getMeasuredToolbarDimensions, getIsInNonDefaultBreakpointMode], (measuredToolbarDimensions, isInNonDefaultBreakpointMode) => collectDimensionForAllSizes(isInNonDefaultBreakpointMode ? TOOLBAR_TYPES.MOBILE.ADVANCED_MODULE_WITHOUT_ACCESS : TOOLBAR_TYPES.DESKTOP.ADVANCED_MODULE_WITHOUT_ACCESS, 'width', measuredToolbarDimensions));
const getMeasuredWidthsOfEditableModuleWithoutAccessToolbarSizes = createSelector([getMeasuredToolbarDimensions], measuredToolbarDimensions => {
  return collectDimensionForAllSizes(TOOLBAR_TYPES.DESKTOP.EDITABLE_MODULE_WITHOUT_ACCESS, 'width', measuredToolbarDimensions);
});
const getMeasuredWidthsOfStaticModuleToolbarSizes = createSelector(getMeasuredToolbarDimensions, getIsInNonDefaultBreakpointMode, (measuredToolbarDimensions, isInNonDefaultBreakpointMode) => collectDimensionForAllSizes(isInNonDefaultBreakpointMode ? TOOLBAR_TYPES.MOBILE.MODULE_OUTSIDE_CONTAINER_TOOLBAR_TYPE : TOOLBAR_TYPES.DESKTOP.MODULE_OUTSIDE_CONTAINER_TOOLBAR_TYPE, 'width', measuredToolbarDimensions));
const getMeasuredWidthsOfEmptyContainerToolbarSizes = createSelector(getMeasuredToolbarDimensions, getIsInNonDefaultBreakpointMode, (measuredToolbarDimensions, isInNonDefaultBreakpointMode) => collectDimensionForAllSizes(isInNonDefaultBreakpointMode ? TOOLBAR_TYPES.MOBILE.EMPTY_CONTAINER_TOOLBAR_TYPE : TOOLBAR_TYPES.DESKTOP.EMPTY_CONTAINER_TOOLBAR_TYPE, 'width', measuredToolbarDimensions));

// TODO: CR - See if we can isolate this to a MODULE drag handle to make these keys required

const getMeasuredWidthHelperFor = ({
  dragHandle,
  measuredWidthsOfDndAreaModuleToolbarSizes,
  measuredWidthsOfStaticModuleToolbarSizes,
  measuredWidthsOfModuleInFlexColumnToolbarSizes,
  measuredWidthsOfModuleInRichTextToolBarSizes,
  isDataAuthoringModeActive
}) => {
  if (dragHandle.isStaticModule || dragHandle.isGlobalGroup || dragHandle.isGlobalPartial) {
    return measuredWidthsOfStaticModuleToolbarSizes;
  } else if (dragHandle.isPostBodyModule || dragHandle.isModuleInRichText) {
    return measuredWidthsOfModuleInRichTextToolBarSizes;
  } else if (dragHandle.isFlexColumnModule) {
    return measuredWidthsOfModuleInFlexColumnToolbarSizes;
  } else if (isDataAuthoringModeActive) {
    // @TODO: This needs rethinking because not all SCP modules use static toolbar sizes by default
    return measuredWidthsOfStaticModuleToolbarSizes;
  } else {
    return measuredWidthsOfDndAreaModuleToolbarSizes;
  }
};
export const getSelectedItemPositionInfo = repackagedCreateSelector(getSelectedItemId, getSelectedContainerId, getNodePositionsByConfigAndId, (selectedItemId, selectedContainerId, nodePositionsByConfigAndId) => {
  if (selectedItemId) {
    const selectedInfo = findNodePositionForLookupId(nodePositionsByConfigAndId, selectedItemId, selectedContainerId);
    // if we can't find the position, it's still helpful to have the selectedItemId
    // particularly when a module is newly added to the page
    return selectedInfo || {
      id: selectedItemId,
      __isFakeNodePosition: true
    };
  }
  return undefined;
});
export const getHighlightedNodePositionInfo = repackagedCreateSelector(getHighlightedWidgetId, getHighlightedWidgetContainerId, getNodePositionsByConfigAndId, (highlightedWidgetId, highlightedWidgetContainerId, nodePositionsByConfigAndId) => {
  if (highlightedWidgetId) {
    const highlightedWidgetInfo = findNodePositionForLookupId(nodePositionsByConfigAndId, highlightedWidgetId, highlightedWidgetContainerId);
    return highlightedWidgetInfo;
  }
  return undefined;
});
export const getHasTopmostRowToolbarHovered = createSelector(getHoveredDragHandleType, getDeepestHoveredNodePositionInfo, getIsAnythingDragging, (hoveredDragHandleType, deepestNodeInfo, isAnythingDragging) => Boolean(hoveredDragHandleType === TOPMOST_SECTION_ROW_DRAG_HANDLE || !isAnythingDragging && deepestNodeInfo && deepestNodeInfo.isRow && deepestNodeInfo.depth === 1));
export const getHasTopmostRowToolbarHoveredOrSelected = createSelector(getHasTopmostRowToolbarHovered, getSelectedItemPositionInfo, (hasTopmostRowToolbarHovered, selectedItemPositionInfo) => {
  if (selectedItemPositionInfo) {
    return Boolean(selectedItemPositionInfo.isRow && selectedItemPositionInfo.depth === 1);
  }
  return hasTopmostRowToolbarHovered;
});
export const getHasModuleToolbarHovered = createSelector(getHoveredDragHandleType, hoveredDragHandleType => hoveredDragHandleType === MODULE_DRAG_HANDLE);
export const getHasColumnToolbarHoveredOrSelected = createSelector(getHoveredDragHandleType, getDeepestHoveredNodePositionInfo, getIsAnythingDragging, getSelectedItemPositionInfo, (hoveredDragHandleType, deepestNodeInfo, isAnythingDragging, selectedItemPositionInfo) => {
  if (selectedItemPositionInfo) {
    return Boolean(selectedItemPositionInfo.isColumn && !selectedItemPositionInfo.isModule && !selectedItemPositionInfo.isRow && !selectedItemPositionInfo.isTopMostRow);
  }
  return Boolean(hoveredDragHandleType === COLUMN_DRAG_HANDLE || !isAnythingDragging && deepestNodeInfo && deepestNodeInfo.isColumn && !deepestNodeInfo.isModule && !deepestNodeInfo.isRow && !deepestNodeInfo.isTopMostRow);
});
export const getHasRowToolbarHoveredOrSelected = createSelector(getHoveredDragHandleType, getDeepestHoveredNodePositionInfo, getIsAnythingDragging, getSelectedItemPositionInfo, (hoveredDragHandleType, deepestNodeInfo, isAnythingDragging, selectedItemPositionInfo) => {
  const isHoveredDragHandleOrDeepestNodeIsRow = Boolean(hoveredDragHandleType === ROW_DRAG_HANDLE || !isAnythingDragging && deepestNodeInfo && deepestNodeInfo.isRow && !(deepestNodeInfo.depth === 1));
  if (selectedItemPositionInfo) {
    return Boolean(selectedItemPositionInfo.isRow && !(selectedItemPositionInfo.depth === 1));
  }
  return isHoveredDragHandleOrDeepestNodeIsRow;
});
export const getHoveredToolbarInfo = createSelector(getHasRowToolbarHoveredOrSelected, getHasColumnToolbarHoveredOrSelected, getHasModuleToolbarHovered, getHasTopmostRowToolbarHoveredOrSelected, getDeepestHoveredNodePositionInfo, (hasRowToolbarHoveredOrSelected, hasColumnToolbarHoveredOrSelected, hasModuleToolbarHovered, hasTopmostRowToolbarHoveredOrSelected, deepestHoveredNodePositionInfo) => {
  const hasToolbarHovered = hasRowToolbarHoveredOrSelected || hasColumnToolbarHoveredOrSelected || hasModuleToolbarHovered || hasTopmostRowToolbarHoveredOrSelected;
  if (hasToolbarHovered) {
    return deepestHoveredNodePositionInfo;
  }
  return null;
});
export const getHoveredModuleRowOrColumnInfo = createSelector(getHoveredPositionsDeepestFirst, getDeepestHoveredNodePositionInfo, getCurrentHoveredDragHandle, getIsAnythingDragging, getShouldCalculateContainerToolbars, getNodePositionsByConfigAndId, getIsAnyResizeHandleHovered, getHasTopmostRowToolbarHoveredOrSelected, (hoveredPositionsDeepestFirst, deepestNodeInfo, currentHoveredDragHandle, isAnythingDragging, shouldCalculateContainerToolbars, nodePositionsByConfigAndId, isResizeHandleHovered, hasTopmostRowToolbarHoveredOrSelected) => {
  const canShowHoverUI = !isAnythingDragging && !isResizeHandleHovered;
  if (canShowHoverUI) {
    //used for checking if user is dragging a section
    const isTopMostRow = hasTopmostRowToolbarHoveredOrSelected;
    if (currentHoveredDragHandle) {
      const hoverItem = hoveredPositionsDeepestFirst.find(pos => pos.id === currentHoveredDragHandle.id);

      // Get the position of the node referenced by the currently hovered toolbar
      const nodePosition = hoverItem && findNodePositionFor(nodePositionsByConfigAndId, hoverItem);
      if (nodePosition) {
        return nodePosition;
      }
    } else if (deepestNodeInfo) {
      const {
        isColumn,
        numChildRows,
        isRow,
        numChildColumns,
        isStaticModule,
        isFlexColumnModule,
        isGlobalGroup,
        isGlobalPartial,
        isFixedPosition,
        isAbsolutePosition,
        isPostBodyModule,
        isModuleInRichText,
        depth
      } = deepestNodeInfo;
      const hasNonStaticPosition = isFixedPosition || isAbsolutePosition;
      const isAnyThingOutsideDndArea = isStaticModule || isFlexColumnModule || isGlobalGroup || isGlobalPartial || hasNonStaticPosition || isPostBodyModule || isModuleInRichText;
      if (depth && depth > 0) {
        if (
        // Show a "module" overlay for an empty column or row
        isColumn && numChildRows === 0 || isRow && numChildColumns === 0 || !isResizeHandleHovered && shouldCalculateContainerToolbars || isTopMostRow) {
          return deepestNodeInfo;
        }
      } else if (isAnyThingOutsideDndArea) {
        // If the deepest node info is outside a layout section, just return that as the hovered module info
        return deepestNodeInfo;
      }
    }
  }
  return null;
});
export const getIsInlineEditableFieldFocused = createSelector([getLayoutSectionDndState], layoutSectionDndState => layoutSectionDndState.isInlineEditableFieldFocused);
const getCurrentModuleToolbarInfoAuthDeps = createSelector([getIsMissingAccessToSomeAdvancedModule, getHasPaymentsReadAccess, getHasPersonalizationAccess], (isMissingAccessToSomeAdvancedModule, hasPaymentsAccess, hasPersonalizationAccess) => ({
  isMissingAccessToSomeAdvancedModule,
  hasPaymentsAccess,
  hasPersonalizationAccess
}));
const getCurrentModuleToolbarSizes = createSelector([getMeasuredWidthsOfDndAreaModuleToolbarSizes, getMeasuredWidthsOfStaticModuleToolbarSizes, getMeasuredWidthsOfModuleInFlexColumnToolbarSizes, getMeasuredWidthsOfModuleInRichTextToolBarSizes, getMeasuredWidthsOfAdvancedModuleWithoutAccessToolbarSizes, getMeasuredWidthsOfEditableModuleWithoutAccessToolbarSizes], (measuredWidthsOfDndAreaModuleToolbarSizes, measuredWidthsOfStaticModuleToolbarSizes, measuredWidthsOfModuleInFlexColumnToolbarSizes, measuredWidthsOfModuleInRichTextToolBarSizes, measuredWidthsOfAdvancedModuleWithoutAccessToolbarSizes, measuredWidthsOfEditableModuleWithoutAccessToolbarSizes) => ({
  measuredWidthsOfDndAreaModuleToolbarSizes,
  measuredWidthsOfStaticModuleToolbarSizes,
  measuredWidthsOfModuleInFlexColumnToolbarSizes,
  measuredWidthsOfModuleInRichTextToolBarSizes,
  measuredWidthsOfAdvancedModuleWithoutAccessToolbarSizes,
  measuredWidthsOfEditableModuleWithoutAccessToolbarSizes
}));
const getCurrentModuleToolbarHandleInfo = createSelector([getIsDraggingResizeHandle, getIsAnyResizeHandleHovered, getHasInsertNewSectionHandleHovered], (isDraggingResizeHandle, isResizeHandleHovered, isInsertNewSectionHandleHovered) => ({
  isDraggingResizeHandle,
  isResizeHandleHovered,
  isInsertNewSectionHandleHovered
}));
const getSelectedItemInfo = createSelector([getSelectedItemId, getSelectedItemPositionInfo], (selectedItemId, selectedItemPositionInfo) => ({
  selectedItemId,
  selectedItemPositionInfo
}));
export const getCurrentModuleToolbarInfo = repackagedCreateSelector([getCurrentDragHandles, getNodePositionsByConfigAndId, getPreviewViewportWidth, getScrollLeftPosition, getIsPatagoniaSidebarCollapsed, getIsDataAuthoringModeActive, getIsInlineEditableFieldFocused, getCurrentModuleToolbarInfoAuthDeps, getCurrentModuleToolbarSizes, getCurrentModuleToolbarHandleInfo, getSelectedItemInfo], (currentDragHandles, nodePositionsByConfigAndId, previewViewportWidth, scrollLeftPosition, isPatagoniaSidebarCollapsed, isDataAuthoringModeActive, isInlineEditableFieldFocused, authDeps, currentModuleToolbarSizes, currentModuleToolbarHandleInfo, selectedItemInfo) => {
  const {
    isDraggingResizeHandle,
    isResizeHandleHovered,
    isInsertNewSectionHandleHovered
  } = currentModuleToolbarHandleInfo;
  const {
    selectedItemId,
    selectedItemPositionInfo
  } = selectedItemInfo;
  const {
    isMissingAccessToSomeAdvancedModule,
    hasPaymentsAccess,
    hasPersonalizationAccess
  } = authDeps;
  const {
    measuredWidthsOfDndAreaModuleToolbarSizes,
    measuredWidthsOfStaticModuleToolbarSizes,
    measuredWidthsOfModuleInFlexColumnToolbarSizes,
    measuredWidthsOfModuleInRichTextToolBarSizes,
    measuredWidthsOfAdvancedModuleWithoutAccessToolbarSizes,
    measuredWidthsOfEditableModuleWithoutAccessToolbarSizes
  } = currentModuleToolbarSizes;
  const canShowModuleToolbar = !isDraggingResizeHandle && !isResizeHandleHovered && !isInsertNewSectionHandleHovered;
  if (!canShowModuleToolbar || selectedItemPositionInfo && !selectedItemPositionInfo.isModule) {
    return null;
  }
  const useItemPosition = selectedItemPositionInfo && !(selectedItemPositionInfo.id === 'post_body' || selectedItemPositionInfo.isPostBodyModule);
  const dragHandleOrHoverItem = useItemPosition ? selectedItemPositionInfo : getDragHandleByType(currentDragHandles, MODULE_DRAG_HANDLE);
  if (dragHandleOrHoverItem) {
    const id = dragHandleOrHoverItem.id;
    const type = dragHandleOrHoverItem.type;
    const isStaticModule = dragHandleOrHoverItem.isStaticModule;
    const isStaticSectionModule = dragHandleOrHoverItem.isStaticSectionModule;
    const isFlexColumnModule = dragHandleOrHoverItem.isFlexColumnModule;
    const isPostBodyModule = dragHandleOrHoverItem.isPostBodyModule;
    const isModuleInRichText = dragHandleOrHoverItem.isModuleInRichText;
    const isGlobalGroup = dragHandleOrHoverItem.isGlobalGroup;
    const isGlobalPartial = dragHandleOrHoverItem.isGlobalPartial;
    const isSelected = Boolean(selectedItemId) && id === selectedItemId;
    const showEditModuleOnSelected = shouldShowEditModuleOnSelected({
      isPatagoniaSidebarCollapsed,
      // TODO: CR - This was originally an incorrect parameter
      moduleType: type
    });
    const isStaticOrNestedModule = isStaticModule || isModuleInRichText;
    const shouldShowToolbar = Boolean(!isSelected || isSelected && !(isGlobalGroup || isGlobalPartial));
    const modulePosition = findNodePositionFor(nodePositionsByConfigAndId, dragHandleOrHoverItem);
    if (modulePosition && shouldShowToolbar) {
      const measuredWidths = getMeasuredWidthHelperFor({
        // @ts-expect-error CR - TS says that one of the types in dragHandleOrHoverItem has nothing
        // in common with this param, but you can still reference all of those values on dragHandleOrHoverItem directly
        dragHandle: dragHandleOrHoverItem,
        measuredWidthsOfDndAreaModuleToolbarSizes,
        measuredWidthsOfStaticModuleToolbarSizes,
        measuredWidthsOfModuleInFlexColumnToolbarSizes,
        measuredWidthsOfModuleInRichTextToolBarSizes,
        isDataAuthoringModeActive
      });
      let measuredWidthsToUse = measuredWidths;
      if (isMissingAccessToSomeAdvancedModule && getIsModuleIdInAdvancedModuleIdsWithoutAccessMap(id)) {
        const advancedModuleWithoutAccessInfo = getAdvancedModuleWithoutAccessInfo(id);
        const isEditableModuleWithoutAccess = advancedModuleWithoutAccessInfo.isRichTextModule || advancedModuleWithoutAccessInfo.isHsVideoModule;
        measuredWidthsToUse = isEditableModuleWithoutAccess && id !== 'post_body' ? measuredWidthsOfEditableModuleWithoutAccessToolbarSizes : measuredWidthsOfAdvancedModuleWithoutAccessToolbarSizes;
      } else if (!hasPaymentsAccess && getIsModuleIdInPaymentsModulesWithoutAccessSet(id)) {
        measuredWidthsToUse = measuredWidthsOfAdvancedModuleWithoutAccessToolbarSizes;
      } else if (!hasPersonalizationAccess && getIsModuleInPersonalizationTokensWithoutAccessMap(id)) {
        measuredWidthsToUse = measuredWidthsOfEditableModuleWithoutAccessToolbarSizes;
      }
      const shouldModifyPlacement = isSelected && isInlineEditableFieldFocused && !isStaticOrNestedModule;
      const topModifier = shouldModifyPlacement ? -2 : 1;
      const leftModifer = shouldModifyPlacement ? 2 : -1;
      const toolbarHeight = PINNED_TOOLBAR_HEIGHT;
      const {
        responsiveSize,
        top: adjustedTop,
        left: adjustedLeft,
        width
      } = adjustResponsiveToolbarToStayInViewPort({
        measuredWidths: measuredWidthsToUse,
        left: modulePosition.left + leftModifer,
        top: modulePosition.top + topModifier,
        width: modulePosition.width,
        previewViewportWidth,
        scrollLeftPosition,
        toolbarHeight,
        isSelected,
        showEditModuleOnSelected
      });
      const result = {
        type,
        id,
        layoutSectionId: dragHandleOrHoverItem.layoutSectionId,
        depth: dragHandleOrHoverItem.depth,
        top: adjustedTop,
        width,
        left: adjustedLeft,
        height: toolbarHeight,
        isFixedPosition: modulePosition.isFixedPosition,
        isStaticModule,
        isStaticSectionModule,
        isPostBodyModule,
        isModuleInRichText,
        isFlexColumnModule,
        isGlobalGroup,
        isGlobalPartial,
        responsiveSize
      };
      return result;
    }
  }
  return null;
});
const getIsSectionsEnabled = () => getFeatureFlag(FEATURE_FLAGS.sections);
export const getCurrentInsertNewSectionToolbarInfo = createSelector(getCurrentDragHandles, getTargetedLayoutSectionId, getTargetedDndAreaNodePositionsById, getShouldCalculateContainerToolbars, getMeasuredWidthsOfInsertNewSectionHandleSizes, getIsDraggingResizeHandle, getNodePositionsByConfigAndId, getSecondToLastHoveredItem, getIsSectionsEnabled, (currentDragHandles, targetedLayoutSectionId, targetedNodePositionsById, shouldCalculateContainerToolbars, measuredWidthsOfInsertNewSectionHandleSizes, isDraggingResizeHandle, nodePositionsByConfigAndId, sectionHoverPosition, isSectionsEnabled) => {
  const canShowInsertNewSectionToolbar = shouldCalculateContainerToolbars && !isDraggingResizeHandle && targetedNodePositionsById && isSectionsEnabled;
  if (!canShowInsertNewSectionToolbar) {
    return null;
  }
  const handle = getDragHandleByType(currentDragHandles, INSERT_NEW_SECTION_HANDLE);
  const nodePosition = findNodePositionFor(nodePositionsByConfigAndId, handle);
  if (handle && nodePosition && sectionHoverPosition) {
    const type = handle.type;
    const responsiveSize = findAppropriateToolbarSize(measuredWidthsOfInsertNewSectionHandleSizes, nodePosition.width);
    const handleWidth = measuredWidthsOfInsertNewSectionHandleSizes[responsiveSize];
    let targetBeforeOrAfter;
    let top;
    let highlightTop;
    if (sectionHoverPosition.topOrBottomHovered === TOP) {
      targetBeforeOrAfter = BEFORE;
      top = nodePosition.top - ROUNDED_BUTTON_HEIGHT / 2;
      highlightTop = nodePosition.top;
    } else {
      targetBeforeOrAfter = AFTER;
      top = nodePosition.bottom - ROUNDED_BUTTON_HEIGHT / 2;
      highlightTop = nodePosition.top + nodePosition.height;
    }
    const left = nodePosition.left + nodePosition.width / 2 - handleWidth / 2;

    // Somewhat hacky fix to prevent top-most-row action toolbars from bleeding off the top-most
    // IPEUI iframe edge.
    if (top < 0) {
      top = 0;
    }
    return {
      type,
      id: handle.id,
      layoutSectionId: targetedLayoutSectionId,
      targetBeforeOrAfter,
      isEmptyLayoutSection: handle.isEmptyLayoutSection,
      parentId: handle.parentId,
      depth: handle.depth,
      top,
      left,
      height: ROUNDED_BUTTON_HEIGHT,
      width: handleWidth,
      highlightTop,
      highlightLeft: nodePosition.left,
      highlightWidth: nodePosition.width,
      responsiveSize
    };
  }
  return null;
});
export const getCurrentRowToolbarInfo = createSelector(getCurrentDragHandles, getTargetedLayoutSectionIdIfNothingIsSelected, getTargetedTree, getShouldCalculateContainerToolbars, getMeasuredHeightsOfRowToolbarSizes, getMeasuredHeightsOfRowToolbarWithHideIconSizes, getIsDraggingResizeHandle, getHasInsertNewSectionHandleHovered, getNodePositionsByConfigAndId, getHasRowToolbarHoveredOrSelected, getSelectedItemPositionInfo, getIsInNonDefaultBreakpointMode, (currentDragHandles, targetedLayoutSectionIdIfNothingIsSelected, targetedTree, shouldCalculateContainerToolbars, measuredHeightsOfRowToolbarSizes, measuredHeightsOfRowToolbarWithHideIconSizes, isDraggingResizeHandle, isInsertNewSectionHandleHovered, nodePositionsByConfigAndId, hasRowToolbarHoveredOrSelected, selectedItemPositionInfo, isInNonDefaultBreakpointMode) => {
  const canShowRowToolbar = (shouldCalculateContainerToolbars || hasRowToolbarHoveredOrSelected) && !isDraggingResizeHandle && !isInsertNewSectionHandleHovered;
  if (!canShowRowToolbar) {
    return null;
  }
  const dragHandleOrHoverItem = selectedItemPositionInfo !== null && selectedItemPositionInfo !== void 0 ? selectedItemPositionInfo : getDragHandleByType(currentDragHandles, ROW_DRAG_HANDLE);
  const rowPosition = findNodePositionFor(nodePositionsByConfigAndId, dragHandleOrHoverItem);
  if (dragHandleOrHoverItem && rowPosition) {
    const type = dragHandleOrHoverItem.type;
    const id = dragHandleOrHoverItem.id;
    const children = childIdsFromNode(targetedTree, id);
    const shouldUseHideIconSizes = isInNonDefaultBreakpointMode && children.length > 1;
    const measuredHeights = shouldUseHideIconSizes ? measuredHeightsOfRowToolbarWithHideIconSizes : measuredHeightsOfRowToolbarSizes;
    const responsiveSize = findAppropriateToolbarSize(measuredHeights, rowPosition.height);
    const isSelected = selectedItemPositionInfo && selectedItemPositionInfo.id === id;
    const offset = isSelected && responsiveSize === 'default' ? SELECTED_TOOLBAR_OFFSET : 0;
    const height = measuredHeights[responsiveSize] - offset;
    let left = rowPosition.left;
    const top = rowPosition.top + (rowPosition.height - height) / 2;

    // Somewhat hacky fix to prevent row action toolbars from bleeding off the left-most
    // IPEUI iframe edge.
    if (left < EDGE_TOOLBAR_HEIGHT) {
      left = EDGE_TOOLBAR_HEIGHT;
    } else if (left < 0) {
      left = 0;
    }

    // Simulate the cordinates the toolbar will seem appear after translated
    const perceivedPosition = {
      top,
      left: left - EDGE_TOOLBAR_HEIGHT
    };
    const layoutSectionId = targetedLayoutSectionIdIfNothingIsSelected || dragHandleOrHoverItem.layoutSectionId;
    const result = {
      type,
      id: dragHandleOrHoverItem.id,
      layoutSectionId,
      parentId: dragHandleOrHoverItem.parentId,
      depth: dragHandleOrHoverItem.depth,
      top,
      height,
      left,
      width: EDGE_TOOLBAR_HEIGHT,
      perceivedPosition,
      responsiveSize
    };
    return result;
  }
  return null;
});
export const getCurrentColumnToolbarInfo = createSelector(getCurrentDragHandles, getTargetedLayoutSectionIdIfNothingIsSelected, getShouldCalculateContainerToolbars, getMeasuredWidthsOfColumnToolbarSizes, getIsDraggingResizeHandle, getIsAnyResizeHandleHovered, getHasInsertNewSectionHandleHovered, getNodePositionsByConfigAndId, getHasColumnToolbarHoveredOrSelected, getSelectedItemPositionInfo, (currentDragHandles, targetedLayoutSectionIdIfNothingIsSelected, shouldCalculateContainerToolbars, measuredWidthsOfColumnToolbarSizes, isDraggingResizeHandle, isResizeHandleHovered, isInsertNewSectionHandleHovered, nodePositionsByConfigAndId, hasColumnToolbarHoveredOrSelected, selectedItemPositionInfo) => {
  const canShowColumnToolbar = (shouldCalculateContainerToolbars || hasColumnToolbarHoveredOrSelected) && !isDraggingResizeHandle && !isResizeHandleHovered && !isInsertNewSectionHandleHovered;
  if (!canShowColumnToolbar) {
    return null;
  }
  const dragHandleOrHoverItem = selectedItemPositionInfo !== null && selectedItemPositionInfo !== void 0 ? selectedItemPositionInfo : getDragHandleByType(currentDragHandles, COLUMN_DRAG_HANDLE);
  const columnPosition = findNodePositionFor(nodePositionsByConfigAndId, dragHandleOrHoverItem);
  if (dragHandleOrHoverItem && columnPosition) {
    const type = dragHandleOrHoverItem.type;
    const id = dragHandleOrHoverItem.id;
    const responsiveSize = findAppropriateToolbarSize(measuredWidthsOfColumnToolbarSizes, columnPosition.width);
    const isSelected = selectedItemPositionInfo && selectedItemPositionInfo.id === id;
    const offset = isSelected && responsiveSize === 'default' ? SELECTED_TOOLBAR_OFFSET : 0;
    const actionToolbarWidth = measuredWidthsOfColumnToolbarSizes[responsiveSize] - offset;
    let top = columnPosition.top - EDGE_TOOLBAR_HEIGHT;

    // Somewhat hacky fix to prevent top-most-row column action toolbars from bleeding off the top-most
    // IPEUI iframe edge.
    if (top < 0) {
      top = 0;
    }
    const layoutSectionId = targetedLayoutSectionIdIfNothingIsSelected || dragHandleOrHoverItem.layoutSectionId;
    const result = {
      type,
      id: dragHandleOrHoverItem.id,
      layoutSectionId,
      parentId: dragHandleOrHoverItem.parentId,
      depth: dragHandleOrHoverItem.depth,
      left: columnPosition.left + (columnPosition.width - actionToolbarWidth) / 2,
      top,
      height: EDGE_TOOLBAR_HEIGHT,
      width: actionToolbarWidth,
      responsiveSize
    };
    return result;
  }
  return null;
});
export const getCurrentTopmostRowToolbarInfo = createSelector(getCurrentDragHandles, getTargetedLayoutSectionIdIfNothingIsSelected, getShouldCalculateContainerToolbars, getMeasuredWidthsOfSectionToolbarSizes, getIsDraggingResizeHandle, getHasInsertNewSectionHandleHovered, getNodePositionsByConfigAndId, getHasTopmostRowToolbarHoveredOrSelected, getTopMostRowNodeInfo, getSelectedItemPositionInfo, (currentDragHandles, targetedLayoutSectionIdIfNothingIsSelected, shouldCalculateContainerToolbars, measuredWidthsOfSectionToolbarSizes, isDraggingResizeHandle, isInsertNewSectionHandleHovered, nodePositionsByConfigAndId, hasTopmostRowToolbarHoveredOrSelected, topMostRowNodeInfo, selectedItemPositionInfo) => {
  var _ref2, _ref3;
  const canShowTopmostRowToolbar = (shouldCalculateContainerToolbars || hasTopmostRowToolbarHoveredOrSelected) && !isDraggingResizeHandle && !isInsertNewSectionHandleHovered;
  if (!canShowTopmostRowToolbar) {
    return null;
  }
  const dragHandleOrHoverItem = (_ref2 = (_ref3 = selectedItemPositionInfo) !== null && _ref3 !== void 0 ? _ref3 : getDragHandleByType(currentDragHandles, TOPMOST_SECTION_ROW_DRAG_HANDLE)) !== null && _ref2 !== void 0 ? _ref2 : topMostRowNodeInfo;
  const rowPosition = findNodePositionFor(nodePositionsByConfigAndId, dragHandleOrHoverItem);
  if (dragHandleOrHoverItem && rowPosition) {
    const id = dragHandleOrHoverItem.id;
    const type = dragHandleOrHoverItem.type;
    const responsiveSize = findAppropriateToolbarSize(measuredWidthsOfSectionToolbarSizes, rowPosition.width);
    const isSelected = selectedItemPositionInfo && selectedItemPositionInfo.id === id;
    const offset = isSelected && responsiveSize === 'default' ? SELECTED_TOOLBAR_OFFSET : 0;
    const actionToolbarWidth = measuredWidthsOfSectionToolbarSizes[responsiveSize] - offset;
    let top = rowPosition.top - EDGE_TOOLBAR_HEIGHT;

    // Somewhat hacky fix to prevent top-most-row action toolbars from bleeding off the top-most
    // IPEUI iframe edge.
    if (top < 0) {
      top = 0;
    }
    const layoutSectionId = targetedLayoutSectionIdIfNothingIsSelected || dragHandleOrHoverItem.layoutSectionId;
    return {
      type,
      id: dragHandleOrHoverItem.id,
      layoutSectionId,
      parentId: dragHandleOrHoverItem.parentId,
      depth: dragHandleOrHoverItem.depth,
      top,
      left: rowPosition.left,
      height: EDGE_TOOLBAR_HEIGHT,
      width: actionToolbarWidth,
      responsiveSize
    };
  }
  return null;
});
export const getCurrentEmptyContainerToolbarInfo = repackagedCreateSelector([getCurrentDragHandles, getTargetedLayoutSectionId, getTargetedDndAreaNodePositionsById, getPreviewViewportWidth, getScrollLeftPosition, getMeasuredWidthsOfEmptyContainerToolbarSizes, getIsDraggingResizeHandle, getNodePositionsByConfigAndId], (currentDragHandles, targetedLayoutSectionId, targetedDndAreaNodePositionsById, previewViewportWidth, scrollLeftPosition, measuredWidthsOfEmptyContainerToolbarSizes, isDraggingResizeHandle, nodePositionsByConfigAndId) => {
  const canShowToolbar = !isDraggingResizeHandle && !!targetedDndAreaNodePositionsById;
  if (!canShowToolbar) {
    return null;
  }
  const dragHandle = getDragHandleByType(currentDragHandles, EMPTY_CONTAINER_DRAG_HANDLE);
  const containerPosition = findNodePositionFor(nodePositionsByConfigAndId, dragHandle);
  if (dragHandle && containerPosition) {
    const id = dragHandle.id;
    const type = dragHandle.type;
    const {
      responsiveSize,
      top: adjustedTop,
      left: adjustedLeft,
      width
      // @ts-expect-error TODO: This is missing toolbarHeight, which is required by the util
    } = adjustResponsiveToolbarToStayInViewPort({
      measuredWidths: measuredWidthsOfEmptyContainerToolbarSizes,
      left: containerPosition.left,
      top: containerPosition.top,
      width: containerPosition.width,
      previewViewportWidth,
      scrollLeftPosition
    });
    const result = {
      type,
      id,
      layoutSectionId: targetedLayoutSectionId,
      depth: dragHandle.depth,
      adjustedTop,
      width,
      left: adjustedLeft,
      height: PINNED_TOOLBAR_HEIGHT,
      responsiveSize
    };
    return result;
  }
  return null;
});
const EMPTY_RESIZE_HANDLE_ARRAY = [];
export const getCurrentColumnResizeHandleInfo = createSelector(getTargetedDndAreaNodePositionsById, getCurrentColumnResizeHandles, getHoveredDragHandleType, getIsAnyResizeHandleHovered, getShouldCalculateContainerToolbars, (targetedDndAreaNodePositionsById, currentColumnResizeHandles, hoveredDragHandleType, isResizeHandleHovered, shouldCalculateContainerToolbars) => {
  const resizeHandlePositionInfo = [];
  if (shouldCalculateContainerToolbars && currentColumnResizeHandles && targetedDndAreaNodePositionsById && (!hoveredDragHandleType || isResizeHandleHovered)) {
    let parentRow;
    currentColumnResizeHandles.forEach(resizeHandle => {
      const handleType = resizeHandle.type;
      let leftColumn;
      let rightColumn;
      if (handleType === resizeHandleTypes.RESIZE_HANDLE_BETWEEN) {
        leftColumn = targetedDndAreaNodePositionsById[resizeHandle.leftId];
        rightColumn = targetedDndAreaNodePositionsById[resizeHandle.rightId];
        if (leftColumn) {
          parentRow = targetedDndAreaNodePositionsById[leftColumn.parentId];
        }
      } else if (handleType === resizeHandleTypes.RESIZE_HANDLE_LEFT) {
        rightColumn = targetedDndAreaNodePositionsById[resizeHandle.id];
        if (rightColumn) {
          leftColumn = targetedDndAreaNodePositionsById[rightColumn.previousColumnId];
          parentRow = targetedDndAreaNodePositionsById[rightColumn.parentId];
        }
      } else if (handleType === resizeHandleTypes.RESIZE_HANDLE_RIGHT) {
        leftColumn = targetedDndAreaNodePositionsById[resizeHandle.id];
        if (leftColumn) {
          rightColumn = targetedDndAreaNodePositionsById[leftColumn.nextColumnId];
          parentRow = targetedDndAreaNodePositionsById[leftColumn.parentId];
        }
      }
      const positionInfo = getPositionInfoForResizeHandle(leftColumn, rightColumn, parentRow);
      if (positionInfo) {
        positionInfo.type = handleType;
        resizeHandlePositionInfo.push(positionInfo);
      }
    });

    // If we are only showing one left or right handle, check if there are any other
    // handles we should be showing higher up the tree.
    if (resizeHandlePositionInfo.length === 1) {
      const {
        type
      } = resizeHandlePositionInfo[0];
      if (type === resizeHandleTypes.RESIZE_HANDLE_LEFT || type === resizeHandleTypes.RESIZE_HANDLE_RIGHT) {
        const oppositeHandleToShow = type === resizeHandleTypes.RESIZE_HANDLE_LEFT ? resizeHandleTypes.RESIZE_HANDLE_RIGHT : resizeHandleTypes.RESIZE_HANDLE_LEFT;
        // Check to see if parent row of this column has it's own parent column
        if (parentRow && parentRow.parentId) {
          const parentColumn = targetedDndAreaNodePositionsById[parentRow.parentId];
          const grandParentRow = targetedDndAreaNodePositionsById[parentColumn.parentId];
          if (grandParentRow) {
            let leftColumn;
            let rightColumn;
            if (oppositeHandleToShow === resizeHandleTypes.RESIZE_HANDLE_LEFT) {
              leftColumn = targetedDndAreaNodePositionsById[parentColumn.previousColumnId];
              rightColumn = parentColumn;
            } else {
              leftColumn = parentColumn;
              rightColumn = targetedDndAreaNodePositionsById[parentColumn.nextColumnId];
            }
            const positionInfo = getPositionInfoForResizeHandle(leftColumn, rightColumn, grandParentRow);
            if (positionInfo) {
              positionInfo.type = oppositeHandleToShow;
              resizeHandlePositionInfo.push(positionInfo);
            }
          }
        }
      }
    }
  }

  // Always re-use the same exact array for empty resize info, so that we can still use === equality
  // in components to check if anything changed (at least in the basic empty case)
  if (resizeHandlePositionInfo.length === 0) {
    return EMPTY_RESIZE_HANDLE_ARRAY;
  }
  return resizeHandlePositionInfo;
});
const simpleBoundsHash = posInfo => {
  return [posInfo.top, posInfo.left, posInfo.width, posInfo.height].join(',');
};
export const getGridPositions = createSelector(getIsAnythingDragging, getCurrentTopmostRowIdWithDragHandle, getTargetedOrNearbyDndAreaNodePositionsById, getNodePositionsByTreeId, getIsMouseInIFrame, getCurrentDragItem, getTargetedTree, getCurrentDeepestRowOrColumnIdWithDragHandle, getTargetedDndAreaNodePositionsById, getHoveredSectionId, getSelectedItemPositionInfo, (isAnythingDragging, currentTopmostRowIdWithDragHandle, targetedDndAreaNodePositionsById, nodePositionsByTreeId, isMouseInIFrame, currentDragItem, targetedTree, currentDeepestRowOrColumnIdWithDragHandle, targetedNodePositionsById, hoveredSectionId, selectedItemPositionInfo) => {
  const cellOutlinesForGrid = {
    cellPositions: [],
    gutterLinePositions: []
  };
  let rowPositions = [];
  const nodesToGatherParentsFrom = [];

  // Being careful to only use the part of Set that works in IE 11
  const hashedBoundsAlreadyAdded = new Set();
  const addNewCellPosition = (cellId, posInfo, positionsLookup = targetedDndAreaNodePositionsById) => {
    if (!posInfo) {
      posInfo = positionsLookup[cellId];
    }

    // Null check in case the nodePositions haven't yet been updated with the same
    // data as the LayoutTree.
    if (posInfo && posInfo.hasBounds) {
      const boundsHash = simpleBoundsHash(posInfo);

      // Ensure that we prevent duplicate bounds from being added (both when the same ID is added
      // twice _and_ when multiple cells have the same bounds)
      if (!hashedBoundsAlreadyAdded.has(boundsHash)) {
        const newPos = {
          top: posInfo.top,
          left: posInfo.left,
          right: posInfo.right,
          bottom: posInfo.bottom,
          width: posInfo.width,
          height: posInfo.height
        };
        cellOutlinesForGrid.cellPositions.push(newPos);

        // Add the new positions bound hash to the set to compare against other positions
        hashedBoundsAlreadyAdded.add(boundsHash);
      }
    }
  };
  const addNewRowPosition = (rowName, positionsLookup = targetedDndAreaNodePositionsById) => {
    const posInfo = positionsLookup[rowName];

    // Null check in case the nodePositions haven't yet been updated with the same
    // data as the LayoutTree.
    if (posInfo && posInfo.hasBounds) {
      const boundsHash = simpleBoundsHash(posInfo);

      // Ensure that we prevent duplicate bounds from being added (both when the same ID is added
      // twice _and_ when multiple cells have the same bounds)
      if (!hashedBoundsAlreadyAdded.has(boundsHash)) {
        rowPositions.push({
          top: posInfo.top,
          left: posInfo.left,
          right: posInfo.right,
          bottom: posInfo.bottom,
          width: posInfo.width,
          height: posInfo.height
        });

        // Add the new positions bound hash to the set to compare against other positions
        hashedBoundsAlreadyAdded.add(boundsHash);
      }
    }
  };

  // Show grid around selected module if it is in a dnd section
  if (selectedItemPositionInfo && selectedItemPositionInfo.isModule && selectedItemPositionInfo.layoutSectionId) {
    addNewCellPosition(selectedItemPositionInfo.id, null, nodePositionsByTreeId[selectedItemPositionInfo.layoutSectionId]);
  }
  if (isAnythingDragging && targetedTree && hoveredSectionId && currentDragItem) {
    // Show grid lines around all modules and nested rows/cells in the currently hovered section
    if (!currentDragItem.isTopMostRow) {
      targetedTree.allCells({
        fromName: hoveredSectionId
      }).forEach(cell => {
        addNewCellPosition(cell.getName());
      });
      targetedTree.allRows({
        fromName: hoveredSectionId,
        includeStart: true
      }).forEach(row => {
        addNewRowPosition(row.getName());
      });
    } else {
      const root = targetedTree.getRootCell();
      const topLevelRowNames = root.getRowNames();
      topLevelRowNames.forEach(topLevelRowName => {
        addNewRowPosition(topLevelRowName);
      });
    }
  } else if (isMouseInIFrame) {
    // Grid lines to show when not dragging...
    if (currentTopmostRowIdWithDragHandle && targetedTree.hasRow(currentTopmostRowIdWithDragHandle)) {
      addNewRowPosition(currentTopmostRowIdWithDragHandle, targetedNodePositionsById);
    }
    if (currentDeepestRowOrColumnIdWithDragHandle) {
      // If no handle is hovered, show grid outline around the deepest
      // wrapper row or column
      if (targetedTree.hasCell(currentDeepestRowOrColumnIdWithDragHandle)) {
        nodesToGatherParentsFrom.push(targetedTree.findCell(currentDeepestRowOrColumnIdWithDragHandle).getParentName());
      } else if (targetedTree.hasRow(currentDeepestRowOrColumnIdWithDragHandle)) {
        nodesToGatherParentsFrom.push(targetedTree.findRow(currentDeepestRowOrColumnIdWithDragHandle).getParentName());
      }
      addNewCellPosition(currentDeepestRowOrColumnIdWithDragHandle);
    }
  }

  // Recursively add parents to the cell and row positions
  while (nodesToGatherParentsFrom.length > 0) {
    const currentNodeName = nodesToGatherParentsFrom.pop();
    let currentNode;
    if (targetedTree.hasRow(currentNodeName)) {
      addNewRowPosition(currentNodeName, targetedNodePositionsById);
      currentNode = targetedTree.findRow(currentNodeName);
    } else if (targetedTree.hasCell(currentNodeName)) {
      addNewCellPosition(currentNodeName);
      currentNode = targetedTree.findCell(currentNodeName);
    }
    if (currentNode && currentNode.getParentName() !== targetedTree.getRootName()) {
      nodesToGatherParentsFrom.push(currentNode.getParentName());
    }
  }

  // Filter out undefined positions from tree updates that don't have any node positions yet
  rowPositions = rowPositions.filter(p => !!p);
  return Object.assign({}, cellOutlinesForGrid, {
    rowPositions
  });
});
export const getTemporaryOverlays = createLayoutSectionDndSelector('temporaryOverlays');
export const getTemporaryOverlayNodePositions = createSelector(getTemporaryOverlays, getNodePositionsByTreeId, (temporaryOverlays, nodePositionsByTreeId) => {
  const overlayNodePositions = [];
  temporaryOverlays.forEach(overlay => {
    const treeIds = Object.keys(nodePositionsByTreeId);
    for (const treeId of treeIds) {
      const positionsById = nodePositionsByTreeId[treeId];
      const nodePositionForOverlay = positionsById[overlay.rowId];
      if (nodePositionForOverlay) {
        overlayNodePositions.push(nodePositionForOverlay);
        break;
      }
    }
  });
  return overlayNodePositions;
});
export const getScrollToNodePositionTop = repackagedCreateSelector(getScrollToNodePositionId, getNodePositionsByConfigAndId, (scrollToNodeInfo, nodePositions) => {
  const SCROLL_TO_NODE_POSITION_Y_OFFSET = 75;
  if (!scrollToNodeInfo || !nodePositions) {
    return null;
  }
  const nodePositionToScrollTo = findNodePositionForLookupId(nodePositions, scrollToNodeInfo.nodePositionId, scrollToNodeInfo.layoutSectionId);
  if (nodePositionToScrollTo) {
    return nodePositionToScrollTo.top - SCROLL_TO_NODE_POSITION_Y_OFFSET;
  }
  return null;
});
export const getShouldUseCustomSections = createSelector(getIsSectionsEnabled, getHasTheme, (isSectionsEnabled, hasTheme) => isSectionsEnabled && hasTheme);